import styled, { css } from 'styled-components';
import Icon from '../../icon';
import Typography from '../../typography';
import { pxToRem } from '../../../design-tokens/style-utilities';
export const linkContainerStyles = ({ theme }) => css `
	cursor: pointer;
	display: inline-block;
	margin-right: ${pxToRem(theme.spacing['400'])};

	&:last-child {
		margin-right: 0;
	}
`;
export const LinkContainer = styled.span `
	${linkContainerStyles}
`;
export const linkAnchorStyles = ({ theme, $iconInverted, $colorInverted, }) => css `
	display: grid;
	align-items: center;
	column-gap: ${pxToRem(theme.spacing['200'])};
	text-decoration: none;

	${$iconInverted
    ? css `
				grid-template-areas:
					'link-icon link-text'
					'. link-subtext';

				${LinkIcon} {
					align-self: start;
					transform: scaleX(-1) translateX(0);
					margin-left: 0;
				}
			`
    : css `
				grid-template-areas:
					'link-text'
					'link-subtext';
			`}

	&:hover {
		${LinkLabel} {
			color: ${$colorInverted
    ? theme.colors.medium.textButtonInverseHover
    : theme.colors.highlight.textHover};
		}

		${LinkIcon} {
			color: ${$colorInverted ? theme.colors.blanc.iconButton : theme.colors.highlight.iconHover};
			transform: ${$iconInverted ? `scaleX(-1) ` : ''} translateX(${pxToRem(3)});
		}
	}

	&:active {
		${LinkLabel}, ${LinkIcon} {
			color: ${$colorInverted
    ? theme.colors.action.textButtonInverseActive
    : theme.colors.action.textActive};
		}
	}

	${$colorInverted &&
    css `
		${LinkLabel} {
			color: ${theme.colors.blanc.textButtonInverse};
		}
		${LinkIcon} {
			color: ${theme.colors.blanc.iconButton};
		}
		${LinkSubText} {
			color: ${theme.colors.blanc.textSupportInverse};
		}
	`}
`;
export const LinkAnchor = styled.a `
	${linkAnchorStyles}
`;
export const linkLabelStyles = ({ theme }) => css `
	color: ${theme.colors.base.textLink};
	grid-area: link-text;
`;
export const LinkLabel = styled(Typography) `
	${linkLabelStyles}
`;
export const linkIconStyles = ({ theme }) => css `
	flex: 0 0 auto;
	display: inline-block;
	color: ${theme.colors.highlight.iconInteractive};
	transform: translateX(0);
	transition: transform 0.2s;
	margin-left: ${pxToRem(theme.spacing['200'])};
	grid-area: link-icon;
`;
export const LinkIcon = styled(Icon) `
	${linkIconStyles}
`;
export const linkSubTextStyles = ({ theme }) => css `
	color: ${theme.colors.base.textSupport};
	grid-area: link-subtext;
`;
export const LinkSubText = styled(Typography).attrs({
    variant: 'support-text',
}) `
	${linkSubTextStyles}
`;
